var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.object.plans && _vm.object.plans.length > 0)?_c('show-plan-component',{staticClass:"mt-4",attrs:{"object":_vm.object}}):_vm._e(),(_vm.object.towers && _vm.object.towers.length > 0)?_c('show-tower-component',{staticClass:"mt-4",attrs:{"object":_vm.object}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }